import { formatDate } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { I18nService } from '../../../core/services/i18n.service';
import { PaymentData } from '../../interfaces/payment/payment-data';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';

@Injectable({
  providedIn: 'root'
})
export class PaymentTypeToTableDataMapper {

  i18n = inject(I18nService);
  authService = inject(AuthService);

  constructor() { }

  public map(paymentMethodData: PaymentData, adminMode: boolean = false): DialogTableDataRow[] {
    let dataRow: DialogTableDataRow[] = [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'STATE',
        valueType: 'STATE',
        value: paymentMethodData.status,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTMETHOD',
        i18nValueKey: paymentMethodData.isChargebackCard ? 'CHARGEBACKCARDLABEL'  : paymentMethodData.paymentMethod,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTTYPEDESCRIPTION',
        value: paymentMethodData.title,
      }
    ];
    if (adminMode) {
      dataRow.push({
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'ACTIVATIONSTATUS',
        valueType: 'ACTIVATIONSTATE',
        value: paymentMethodData.active
      });
      if (!paymentMethodData.active) {
        dataRow.push({
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'ENABLEPAYMENTTYPELABEL',
          value: paymentMethodData.activationRequested ? (this.i18n.i18nLng()['YES'] + ' - ' + (paymentMethodData?.activationRequestedAt ? formatDate(paymentMethodData.activationRequestedAt, 'dd.MM.yyyy', 'de') : '')) : this.i18n.i18nLng()['NO']
        });
      }
      if (paymentMethodData?.pspContractStatus) {
        dataRow.push({
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'CONTRACT_STATUS',
          i18nValueKey: 'CONTRACT_' +  paymentMethodData.pspContractStatus + '_STATUS',
        });
      }
    }
    return dataRow;
  }
}
